"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../../actionTypes/vektorio/connect");
const status_1 = require("../../../status");
const utils_1 = require("../utils");
const statuses = (0, utils_1.createRequestStatus)(status_1.RequestType.FETCH);
exports.initialState = {
    linkableProjectsStatus: statuses.standby(),
    connectProjectStatus: statuses.standby(),
    disconnectProjectStatus: statuses.standby(),
    linkableProjects: [],
    selectedProjects: [],
    modalIsOpen: false,
    errors: null
};
const linkableProjectsStatusLens = monocle.Lens.fromProp('linkableProjectsStatus');
const connectProjectStatusLens = monocle.Lens.fromProp('connectProjectStatus');
const disconnectedProjectStatusLens = monocle.Lens.fromProp('disconnectProjectStatus');
const linkableProjectsLens = monocle.Lens.fromProp('linkableProjects');
const modalIsOpenLens = monocle.Lens.fromProp('modalIsOpen');
const errorsLens = monocle.Lens.fromProp('errors');
const selectedProjectsLens = monocle.Lens.fromProp('selectedProjects');
const methods = {};
exports.methods = methods;
methods[ActionTypes.FETCH_LINKABLE_REQUEST] = (state) => fp.function.flow(linkableProjectsStatusLens.set(statuses.fetching()), errorsLens.set(null))(state);
methods[ActionTypes.FETCH_LINKABLE_SUCCESS] = (state, action) => fp.function.flow(linkableProjectsStatusLens.set(statuses.success()), linkableProjectsLens.set(action.payload), selectedProjectsLens.set([]))(state);
methods[ActionTypes.FETCH_LINKABLE_VALIDATION] = (state, action) => fp.function.flow(linkableProjectsStatusLens.set(statuses.standby()), errorsLens.set(action.payload))(state);
methods[ActionTypes.FETCH_LINKABLE_FAILURE] = (state) => linkableProjectsStatusLens.set(statuses.failed())(state);
methods[ActionTypes.SELECT_PROJECT] = (state, action) => selectedProjectsLens.modify((current) => {
    const exist = current.find((project) => project.vektorioId === action.payload.vektorioId);
    if (!exist) {
        return [...current, action.payload];
    }
    return current;
})(state);
methods[ActionTypes.DESELECT_PROJECT] = (state, action) => selectedProjectsLens.modify((current) => current.filter((project) => project.vektorioId !== action.payload.vektorioId))(state);
methods[ActionTypes.CONNECT_REQUEST] = (state) => connectProjectStatusLens.set(statuses.fetching())(state);
methods[ActionTypes.CONNECT_SUCCESS] = (state) => fp.function.flow(connectProjectStatusLens.set(statuses.success()), selectedProjectsLens.set([]))(state);
methods[ActionTypes.CONNECT_FAILURE] = (state) => connectProjectStatusLens.set(statuses.failed())(state);
methods[ActionTypes.DISCONNECT_REQUEST] = (state) => disconnectedProjectStatusLens.set(statuses.fetching())(state);
methods[ActionTypes.DISCONNECT_SUCCESS] = (state) => disconnectedProjectStatusLens.set(statuses.success())(state);
methods[ActionTypes.DISCONNECT_FAILURE] = (state) => disconnectedProjectStatusLens.set(statuses.failed())(state);
methods[ActionTypes.TOGGLE_MODAL] = (state) => modalIsOpenLens.modify((status) => !status)(state);
methods[ActionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=index.js.map